import { type TenantMeta } from "@packsize/identity-api-sdk";
import { orderBy } from "lodash";
import { useQuery } from "@tanstack/react-query";
import { useToken } from "@packsize/authentication";

import { packNetAxios } from "@/lib/api-client";
import { baseRoutes } from "@/api/base-routes";

export const TENANTS_QUERY_KEY = ["tenants"] as const;

const fetchTenants = async (includeDecommissioned: boolean = false): Promise<TenantMeta[]> => {
	const response = await packNetAxios.get(
		`${baseRoutes.identity}/v1/users/tenants?includeDecommissioned=${includeDecommissioned}`,
	);

	//todo - add some schema validation
	return orderBy(response.data ?? [], (a) => a.company.toLowerCase());
};

export const useTenants = (includeDecommissioned: boolean = false) => {
	const { tokenValid } = useToken();
	const queryFn = () => fetchTenants(includeDecommissioned);
	return useQuery<TenantMeta[]>({
		queryKey: TENANTS_QUERY_KEY,
		queryFn,
		initialData: [],
		enabled: tokenValid === true,
	});
};
